import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import vuetify from './plugins/vuetify'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueAxios, axios)